<div class="share-dialog">
  <h1 mat-dialog-title>„{{ data.folderName }}“ teilen</h1>
  <mat-dialog-content>
    <p class="gray intro">
      Laden Sie andere Personen per E-Mail-Adresse ein. Änderungen sind für alle sofort sichtbar. Die Einladung ist
      für Premium-Nutzer mit dieser Adresse sichtbar, auch wenn das Konto erst später angelegt oder freigeschaltet wird. <br>
      <br>
      Mit <b>Ansehen</b> kann die Mappe angesehen, exportiert und dupliziert werden. <br>
      Mit <b>Bearbeiten</b> zusätzlich umbenannt und ihr Inhalt geändert werden.
    </p>
    <form (ngSubmit)="share()" [formGroup]="shareForm" class="share-form pad-top8">
      <mat-form-field appearance="outline" class="share-email">
        <mat-label>E-Mail</mat-label>
        <input formControlName="email" matInput required type="email">
        @if (shareForm.controls.email.hasError('email')) {
          <mat-error>Ungültige E-Mail-Adresse</mat-error>
        }
      </mat-form-field>
      <mat-form-field appearance="outline" class="share-permission">
        <mat-label>Berechtigung</mat-label>
        <mat-select formControlName="permission">
          @for (permission of permissions; track permission) {
            <mat-option [value]="permission">{{ permissionLabels[permission] }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
      <button [disabled]="saving" class="share-button" color="primary" mat-raised-button type="submit">
        <mat-icon>share</mat-icon>
        Teilen
      </button>
    </form>

    <h3 class="mat-h3 m0">Geteilt mit</h3>
    @if (loading) {
      <div class="center-content pad16">
        <mat-progress-spinner diameter="32" mode="indeterminate"></mat-progress-spinner>
      </div>
    } @else if (shares.length === 0) {
      <p class="gray">Diese Sammelmappe ist noch nicht geteilt.</p>
    } @else {
      <table [dataSource]="shares" class="w100" mat-table>
        <ng-container matColumnDef="user">
          <th *matHeaderCellDef mat-header-cell>Person</th>
          <td *matCellDef="let share" mat-cell>{{ recipientName(share) }}</td>
        </ng-container>
        <ng-container matColumnDef="permission">
          <th *matHeaderCellDef mat-header-cell>Berechtigung</th>
          <td *matCellDef="let share" mat-cell>
            <mat-select (selectionChange)="changePermission(share, $event.value)" [value]="share.permission"
                        aria-label="Berechtigung" class="permission-select">
              @for (permission of permissions; track permission) {
                <mat-option [value]="permission">{{ permissionLabels[permission] }}</mat-option>
              }
            </mat-select>
          </td>
        </ng-container>
        <ng-container matColumnDef="status">
          <th *matHeaderCellDef mat-header-cell>Status</th>
          <td *matCellDef="let share" mat-cell>
            @if (share.accepted) {
              <span class="status accepted">angenommen</span>
            } @else {
              <span class="status pending">ausstehend</span>
            }
          </td>
        </ng-container>
        <ng-container matColumnDef="revoke">
          <th *matHeaderCellDef mat-header-cell></th>
          <td *matCellDef="let share" mat-cell>
            <button (click)="revoke(share)" aria-label="Freigabe entfernen" color="warn" mat-icon-button
                    matTooltip="Freigabe entfernen">
              <mat-icon>person_remove</mat-icon>
            </button>
          </td>
        </ng-container>
        <tr *matHeaderRowDef="displayedColumns" mat-header-row></tr>
        <tr *matRowDef="let row; columns: displayedColumns;" mat-row></tr>
      </table>
    }
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button [mat-dialog-close]="changed" mat-raised-button>Schließen</button>
  </mat-dialog-actions>
</div>
